import questionsReducer, {
    fetchQuestions,
    programUpsell,
} from './questionsSlice';

export {fetchQuestions, programUpsell};
export default questionsReducer;
